<template>
	<v-dialog v-model="dialogState" width="500">
		<v-card>
			<v-card-title class="headline primary white--text" primary-title>
				{{ header }}
			</v-card-title>

			<v-card-text>
				{{ info }}
				{{ content }}
			</v-card-text>

			<slot></slot>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="success" flat @click="action" :disabled="disabled">
					<v-icon color="white" class="mr-2">{{ icon }}</v-icon>
					{{ actionLabel }}
				</v-btn>
				<v-btn color="blue" @click="dialogState = false">
					<v-icon color="white" class="mr-2">close</v-icon>
					Anuluj
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "ContestOfferConfirmationDialog",

		data () {
			return {
				dialogState: false,
			};
		},

		watch: {
			dialogModel: function () {
				this.dialogState = this.dialogModel;
			},

			dialogState: function (val) {
				if (!val) this.$emit("close-confirmation");
			}
		},

		props: {
			dialogModel: Boolean,
      		disabled: {type: Boolean, default: false},
			header: String,
			content: String,
			actionLabel: String,
			icon: String,
			action: Function,
			info: {type: String, default: ""}
		},
	};
</script>

<style scoped>

</style>
